import GetPrototypeModulesListRequestModel from '../../../generated/types/model/request/GetPrototypeModulesListRequestModel';

export default class GetPrototypeModulesListRequestViewModel extends GetPrototypeModulesListRequestModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
